window.jsWNWLoad = false;
var hamburgerMenuBtn = document.querySelector("button.mobile-menu");
const bodyEl = document.body;
var mobileDiv = document.querySelector(".mobile__menu-drawer");
var siteNav = document.querySelector(".site-nav__link");
var siteHeader = document.querySelector(".site-header");
var closeSearch = document.querySelector(".close-search-globel");
var templateIndex = document.querySelector(".template-index");
var predictiveSearch = document.querySelector(".predictive__search");
var autoCompleteContainer = document.querySelector(".autocomplete");
const cartToggle = document.querySelector("a.site-header__cart-toggle");
const cartClose = document.querySelector(".js-drawer-close-floating");
const cartCloseOutside = document.querySelector(".overlay_click");
const sideMenuToggle = document.querySelector(".side_menu--toggle");
const sideMenuDrawer = document.querySelector(".side-menu--drawer");

function HandleSideMenu(event) {
  if (window.eventListenerFlag) {
    sideMenuToggle.removeEventListener("click", HandleSideMenu);
    return;
  }
  if (sideMenuToggle.classList.contains("active")) {
    sideMenuToggle.classList.remove("active");
    sideMenuDrawer.classList.remove("active");
    bodyEl.classList.remove("side_menu-active");
  } else {
    sideMenuToggle.classList.add("active");
    sideMenuDrawer.classList.add("active");
    bodyEl.classList.add("side_menu-active");
  }
}
sideMenuToggle.addEventListener("click", HandleSideMenu);


function drawerEventHandler() {
  if (mobileDiv.classList.contains("is-open")) {
    event.preventDefault();
    mobileDiv.classList.remove("is-open");
    bodyEl.classList.remove("js-drawer-open", "js-drawer-open-left");
  } else {
    event.preventDefault();
    mobileDiv.classList.add("is-open");
    bodyEl.classList.add("js-drawer-open", "js-drawer-open-left");
  }
}
hamburgerMenuBtn.addEventListener("click", drawerEventHandler);
document.querySelectorAll(".has-children > a").forEach(function (link) {
  link.addEventListener("click", function (event) {
    event.preventDefault();
    this.nextElementSibling.classList.remove("is-hidden");
    this.parentNode.parentNode.classList.add("move-out");
  });
});

document
  .querySelectorAll(".cd-dropdown-content li.has-children")
  .forEach(function (li) {
    li.addEventListener("mouseenter", function () {
      const first = this.children[0];
      const second = this.children[1];
      if (first) first.classList.add("is-active");
      if (second && !document.querySelector(".cd-dropdown-content .fade-in")) {
        second.classList.add("fade-in");
      }
    });

    li.addEventListener("mouseleave", function () {
      const first = this.children[0];
      const second = this.children[1];
      if (first) first.classList.remove("is-active");
      if (!document.querySelector("li.has-children:hover")) {
        document
          .querySelectorAll(".cd-dropdown-content .fade-in")
          .forEach(function (fadeInElem) {
            fadeInElem.classList.remove("fade-in");
          });
        if (second) second.classList.add("fade-out");
      }
    });
  });

document
  .querySelectorAll(".cd-dropdown-content .go-back")
  .forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default action of the button

      // Find the parent <ul> of the '.go-back' button which should be hidden
      var visibleSubMenu = this.parentNode;
      while (
        visibleSubMenu &&
        !visibleSubMenu.classList.contains("cd-dropdown-icons")
      ) {
        if (visibleSubMenu.tagName === "UL") {
          visibleSubMenu.classList.add("is-hidden");
          break;
        }
        visibleSubMenu = visibleSubMenu.parentNode;
      }

      // Find the corresponding parent menu to make it visible again
      var parentMenuItem = visibleSubMenu.parentNode;
      if (parentMenuItem.classList.contains("move-out")) {
        parentMenuItem.classList.remove("move-out");
      } else {
        // If not move-out then it might be the root ul which needs special handling
        var rootMenu = document.querySelector(".cd-dropdown-content");
        if (rootMenu.classList.contains("move-out")) {
          rootMenu.classList.remove("move-out");
        }
      }
    });
  });

// Select the header element by its ID
var shopifySectionHeader = document.getElementById("shopify-section-header");
var mobileMenu = document.getElementById("Mobile-Menu");
if (shopifySectionHeader) {
  // Get the offset height of the header
  var hdHeight = shopifySectionHeader.offsetHeight;
  mobileMenu.style.top = hdHeight + "px";
  // Select all elements with the class .mega-menu--wrapper
  var elements = document.querySelectorAll(".mega-menu--wrapper");

  // Iterate through the NodeList if elements were found
  if (elements) {
    elements.forEach(function (element) {
      element.style.top = "0px";
      setTimeout(function () {
        element.classList.add("loaded");
        element.style.top = hdHeight + "px";
      }, 100);
    });
  }
} else {
  console.error("Header element not found.");
}
